import OutOfServicePhone from '@/Classes/800/OutOfServicePhone';
export default {
  data() {
    return {
      confimType: '',
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      modalIcon: '',

      ambulance107InformationTableHeaders: [
        { text: 'ناحیه', value: 'zone', align: 'center' },
        { text: 'کد آمبولانس', value: 'ambulanceCode', align: 'center' },
        { text: 'شماره تماس', value: 'phoneNumber', align: 'center' },
        { text: 'توضیحات', value: 'note', align: 'center' },
        { text: 'کاربر', value: 'user', align: 'center' },
        { text: 'زمان 10-7', value: 'time', align: 'center' },
        { text: 'مدت زمان', value: 'duration', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      outOfServicePhone: new OutOfServicePhone.OutOfServicePhone('', null, null),
      minute: null,
      hour: null,
      //extend
      extendTimeModal: false,
      extendHour: null,
      extendMinute: null,
      outOfServicePhoneId: null,
      allActiveAlarmSearchText: '',
      //confirm
      confirmModal: false,
      confirmNote: '',
      confirmHour: null,
      confirmMinute: null,
      //cancel
      cancelModal: false,
      cancelNote: '',
      selectedZone: [],
    };
  },
  methods: {
    setActiveOutOfService: function (item) {
      this.confirmNote = item?.note;
      this.confirmHour = (item?.totalDuration / 60)?.toFixed(0);
      this.confirmMinute = item?.totalDuration % 60;
    },
    resetActiveOutOfService: function () {
      this.confirmNote = '';
    },
    enableAddEditFunction: function (type) {
      if (type == 1) {
        this.getListOfPhonesForOther();
        this.modalTitle = 'افزودن کد';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.outOfServicePhone = new OutOfServicePhone.OutOfServicePhone('', null, null);
      this.minute = null;
      this.hour = null;
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addOutOfServicePhoneFunction();
      } else if (this.confimType == 'extend') {
        this.$refs.confirm.title = 'تمدید زمان';
        this.$refs.confirm.text = 'از تمدید زمان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'end') {
        this.$refs.confirm.title = 'تغییر وضعیت';
        this.$refs.confirm.text = 'از تغییر وضعیت اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'confirm') {
        this.$refs.confirm.title = 'تایید 10-7';
        this.$refs.confirm.text = 'از تایید 10-7 اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'cancel') {
        this.$refs.confirm.title = 'لغو 10-7';
        this.$refs.confirm.text = 'از لغو 10-7 اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addOutOfServicePhoneFunction();
      } else if (this.confimType == 'extend') {
        this.disabelConfirm = true;
        this.extendOutOfServicePhoneFunction();
      } else if (this.confimType == 'end') {
        this.disabelConfirm = true;
        this.endOutOfServicePhoneFunction();
      } else if (this.confimType == 'confirm') {
        this.disabelConfirm = true;
        this.confirmOutOfServicePhoneFunction();
      } else if (this.confimType == 'cancel') {
        this.disabelConfirm = true;
        this.cancelOutOfServicePhoneFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'extend') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'end') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'confirm') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'cancel') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //end
    showEndConfirmFunction: function (id) {
      this.outOfServicePhoneId = id;
      this.confimType = 'end';
      this.showConfirmDialogFunction();
    },
    //times
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    // convert data into two columns group data
    convertIntoTwoColumnGroupList: function (list) {
      const tempData = [];
      [...list]?.forEach((el, index) => {
        if (index < list?.length && index % 2 == 0) {
          const nextItem = list?.[index + 1];
          if (nextItem) {
            const cobminedItem = { item1: { ...el }, item2: { ...nextItem } };
            tempData.push(cobminedItem);
          } else {
            tempData.push({ item1: el });
          }
        }
      });
      return tempData;
    },
    //extends
    showExtendTimeModal: function (id) {
      this.outOfServicePhoneId = id;
      this.confimType = 'extend';
      this.extendTimeModal = true;
    },
    cancelExtendTimetFunction: function () {
      this.extendHour = null;
      this.extendMinute = null;
      this.extendTimeModal = false;
    },
    //confirm cancel
    enableConfirmOrCancel: function (id, type, item) {
      this.outOfServicePhoneId = id;
      if (type == 1) {
        this.setActiveOutOfService(item);
        this.confimType = 'confirm';
        this.confirmModal = true;
      } else if (type == 2) {
        this.confimType = 'cancel';
        this.cancelModal = true;
      }
    },
    cancelConfirmModal: function () {
      this.resetActiveOutOfService();
      this.confirmModal = false;
    },
    cancelCancelModal: function () {
      this.cancelModal = false;
      this.cancelNote = '';
    },
  },
};
